module.exports = __webpack_public_path__ + "img/mr_get.c276a79.png";